import ReactGA from 'react-ga4';

export const initGA = () => {
  ReactGA.initialize('G-K7DJ0T4VBG');
};

export const logPageView = () => {
  ReactGA.send({ hitType: "pageview", page: window.location.pathname });
};
